import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Loading from "./Loading";

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
`

const Animations = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    & img {
        height: 10rem;
    }
`

const TransmittingText = styled.div`
    font-size: 1.5rem;
    font-style: italic;
`

const Transmitting = () => {

    const [transmittingText, setTransmittingText] = useState('Transmitting to Tulna...');
    const navigate = useNavigate();
    const location = useLocation();
    const {results} = location?.state || {};

    useEffect(() => {
        setTimeout(() => {
            setTransmittingText('Receiving Data...')
        }, 2000);
        setTimeout(() => {
            setTransmittingText('Processing in Tulna...')
        }, 3000);
        setTimeout(() => {
            setTransmittingText('Responding...')
        }, 3500);
        setTimeout(() => {
            navigate('/results', {state: {
                results: results
              }})
        }, 5500);
    }, [navigate, results])

    return (
        <Container>
            <Animations>
                <img src={require('assets/img/earth.png')} alt='earth' />
                <Loading iconSize={1.5}/>
                <img src={require('assets/img/amazonia.png')} alt='amazonia' />
            </Animations>
            <TransmittingText>
                {transmittingText}
            </TransmittingText>
        </Container>
    )
}

export default Transmitting;